import { toIsoDateTime } from "@repo/utils/date";
import type { AdminAllowDeliveryInput } from "@/libs/generated/types";

import type { PublishDeliverySchemaType } from "@/schemas/DeliveryForm/publish-delivery";

import {
  type DeliveryClientPriceSource,
  type DeliveryDriverPriceSource,
  getClientPrice,
  roundCurrency,
} from "./delivery-pricing";

type DeliveryPublishPatchInput = Pick<
  AdminAllowDeliveryInput,
  | "carAvailabilityDate"
  | "carDeliveryDeadline"
  | "carPickUpDate"
  | "clientFinalPrice"
  | "maxPrice"
  | "minPrice"
  | "status"
  | "wantedPrice"
>;

export function getDeliveryPublishPatch(
  data: DeliveryClientPriceSource & DeliveryDriverPriceSource,
  input: DeliveryPublishPatchInput
) {
  return {
    ...(input.status ? { status: input.status } : {}),
    wantedPrice: roundCurrency(input.wantedPrice ?? data.wantedPrice ?? 0),
    minPrice: roundCurrency(input.minPrice ?? data.minPrice ?? 0),
    maxPrice: roundCurrency(input.maxPrice ?? data.maxPrice ?? 0),
    clientFinalPrice: roundCurrency(
      input.clientFinalPrice ?? data.clientFinalPrice ?? data.clientInitialPrice ?? 0
    ),
    ...(input.carAvailabilityDate != null
      ? { carAvailabilityDate: input.carAvailabilityDate }
      : {}),
    ...(input.carPickUpDate != null ? { carPickUpDate: input.carPickUpDate } : {}),
    ...(input.carDeliveryDeadline != null
      ? { carDeliveryDeadline: input.carDeliveryDeadline }
      : {}),
  };
}

export function buildPublishPricing(
  value: PublishDeliverySchemaType,
  delivery: DeliveryDriverPriceSource
) {
  return {
    clientFinalPrice: roundCurrency(value.clientFinalPrice ?? getClientPrice(delivery)),
    wantedPrice: roundCurrency(value.wantedPrice ?? delivery.wantedPrice ?? 0),
    minPrice: roundCurrency(value.minPrice ?? delivery.minPrice ?? 0),
    maxPrice: roundCurrency(value.maxPrice ?? delivery.maxPrice ?? 0),
    carAvailabilityDate: toIsoDateTime(value.carAvailabilityDate),
    carPickUpDate: toIsoDateTime(value.carPickUpDate),
    carDeliveryDeadline: toIsoDateTime(value.carDeliveryDeadline),
  };
}

export type PublishPricing = ReturnType<typeof buildPublishPricing>;
